<template>
  <!-- Sticky action bar for multi-select restore on the Monetary/Trades/Notes tabs. -->
  <transition name="bk-bulk">
    <div v-if="count > 0" class="bk-bulk">
      <div class="bk-bulk__count"><span>{{ count }}</span></div>
      <div class="bk-bulk__text">
        <div class="bk-bulk__title">{{ label }}</div>
        <div v-if="balanceCount > 0" class="bk-bulk__balance">
          <i class="fa-solid fa-scale-unbalanced"></i>
          {{ $tc('backup.bulk.toBalance', balanceCount, { n: balanceCount }) }}
          <span v-for="t in balanceTotals" :key="t.currency" class="bk-bulk__amt">{{ bkMoney(t.total, t.currency) }}</span>
        </div>
        <div v-else-if="recordOnlyHint" class="bk-bulk__hint">
          <i class="fa-solid fa-shield-halved"></i> {{ recordOnlyHint }}
        </div>
      </div>
      <b-button variant="link" size="sm" class="ml-auto bk-ghost" @click="$emit('clear')">{{ $t('backup.bulk.clear') }}</b-button>
      <b-button variant="primary" size="sm" class="bk-bulk__go" @click="$emit('restore')">
        <i class="fa-solid fa-rotate-left mr-50"></i>{{ $t('backup.restoreSelected') }}
      </b-button>
    </div>
  </transition>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinBackup from '@/components/mixin/mixinBackup'

export default {
  name: 'BackupBulkBar',
  mixins: [mixinBase, mixinBackup],
  props: {
    count: { type: Number, default: 0 },
    label: { type: String, default: '' },
    balanceCount: { type: Number, default: 0 },
    balanceTotals: { type: Array, default: () => [] },
    recordOnlyHint: { type: String, default: null },
  },
}
</script>

<style scoped lang="scss">
.bk-bulk {
  position: sticky; bottom: 12px; z-index: 5;
  display: flex; align-items: center; gap: 0.75rem;
  margin-top: 0.75rem; padding: 0.6rem 0.8rem 0.6rem 0.6rem;
  border-radius: 14px; background: #fff;
  border: 1px solid rgba(115, 103, 240, 0.35);
  box-shadow: 0 14px 34px -14px rgba(34, 41, 47, 0.45);

  &__count span {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 38px; height: 38px; padding: 0 0.5rem; border-radius: 10px;
    background: #7367f0; color: #fff; font-weight: 800; font-size: 1rem;
  }
  &__title { font-weight: 700; color: #5e5873; }
  &__balance { font-size: 0.8rem; font-weight: 700; color: #e8862a; }
  &__amt { margin-left: 0.4rem; padding: 0.05rem 0.4rem; border-radius: 6px; background: rgba(255, 159, 67, 0.15); }
  &__hint { font-size: 0.78rem; color: #28a76a; }
  &__go { box-shadow: 0 6px 14px -8px rgba(115, 103, 240, 0.9); }
}
.bk-bulk-enter-active, .bk-bulk-leave-active { transition: all 0.18s ease; }
.bk-bulk-enter, .bk-bulk-leave-to { opacity: 0; transform: translateY(8px); }

body.dark-layout {
  .bk-bulk { background: #283046; border-color: rgba(115, 103, 240, 0.5); box-shadow: 0 14px 34px -14px rgba(0, 0, 0, 0.7); }
  .bk-bulk__title { color: #d0d2d6; }
  .bk-bulk__balance { color: #ffb36b; }
}
</style>
